import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VariablesService {

  constructor(private http: HttpClient) { }

  getColumnDefinitions(): Observable<any>{
    return this.http.get(`${environment.yomaApiURL}/resources/i18n/column_definitions`);
  }

  changeColumnDefinitions(obj: any): Observable<any>{
    return this.http.post(`${environment.yomaApiURL}/resources/i18n/column_definitions`, obj);
  }

  saveColumnDefinition(colDef: any): Observable<any> {
    return this.http.put(`${environment.yomaApiURL}/resources/i18n/column_definitions`, colDef)
  }
}
